import { fetchOptions, ajax } from "./api";
import $ from "jquery";
import { getCompositeImageList, getApiKey } from "./../selectors";

export function getDoorRooms() {
    return (dispatch, getState) => {
        dispatch({
            type: "GET_DOOR_ROOMS",
            payload: fetchOptions(getApiKey(getState()), "GetRooms?productSuiteId=2")
        });
    };
}
export function getDoorStyles(doorTypeId) {
    return (dispatch, getState) =>
        dispatch({
            type: "GET_DOOR_STYLES",
            payload: fetchOptions(getApiKey(getState()), "GetStyles?productId=" + doorTypeId)
        });
}

export function getDoorOptions(doorTypeId, roomId) {
    return (dispatch, getState) =>
        dispatch({
            type: "GET_DOOR_OPTIONS",
            payload: fetchOptions(
                getApiKey(getState()),
                "GetProductOptions?productId=" + doorTypeId + "&roomId=" + roomId
            )
        });
}

export const loadWhiteFrame = doorTypeId => {
    return dispatch => {
        ajax("GET", "enquiry/urlresolver", {
            productId: doorTypeId,
            styleId: 0,
            slabExtraId: 0,
            extraGroupId: 0,
            extraId: 0
        }).then(data => {
            const whiteFrame = data.result.entity[0];
            dispatch({
                type: "ADD_PREVIEW",
                payload: { rank: 3, src: whiteFrame.url3 }
            });
        });
    };
};

export function getDoorModels(typeId) {
    return (dispatch, getState) =>
        dispatch({
            type: "GET_DOOR_MODELS",
            payload: fetchOptions(getApiKey(getState()), "GetStyles?productId=" + typeId)
        });
}

export function getDoorTypes(doorRoomId) {
    return (dispatch, getState) =>
        dispatch({
            type: "GET_DOOR_TYPES",
            payload: fetchOptions(
                getApiKey(getState()),
                "GetProducts?suiteId=2&roomId=" + doorRoomId
            )
        });
}

var makeCallbackMaker = (stackSrc, context) => {
    return index => {
        return next => {
            // add a cache buster because the browser caches headers which prevent the use
            // of the images in a canvas
            var imageSrc = stackSrc[index] + "?v=" + new Date().getTime();
            var image = new Image();
            image.crossOrigin = "Anonymous";
            image.onload = () => {
                context.drawImage(image, 0, 0, 191, 386);
                next();
            };

            image.src = imageSrc;
        };
    };
};

export function addDoor(doorValues, doorType) {
    return (dispatch, getState) => {
        let randomIdForImageReplacement = Math.floor(1e10 * Math.random());

        if (doorType.isComposite) {
            var queue = $({});
            var state = getState();
            var canvas = document.createElement("CANVAS");

            canvas.style.position = "fixed";
            canvas.style.top = "0px";
            canvas.style.left = "0px";

            canvas.width = 191;
            canvas.height = 386;

            var context = canvas.getContext("2d");

            var stackSrc = getCompositeImageList(state);

            stackSrc = stackSrc.filter(src => /\.(png|jpg)$/.test(src));

            var makeCallback = makeCallbackMaker(stackSrc, context);

            for (var index in stackSrc) {
                queue.queue(makeCallback(index));
            }
            var imgUrl = "";
            queue.queue(next => {
                imgUrl = canvas.toDataURL("image/png");
                next();
            });

            queue.queue(() => {
                setTimeout(
                    () =>
                        dispatch({
                            type: "LOAD_FLAT_IMAGE",
                            payload: {
                                randomIdForImageReplacement,
                                imgUrl
                            }
                        }),
                    1000
                );
            });
        }

        dispatch({
            type: "ADD_DOOR_TO_LIST",
            payload: {
                ...doorValues,
                IsComposite: doorType.isComposite,
                IsPatioOrBiFold: doorType.isPatioOrBifold,
                FlattenedImageSrc: "",
                randomIdForImageReplacement
            }
        });
    };
}



// WEBPACK FOOTER //
// ./src/actions/door.js